export class URLParamsConstants {
    static TRAVEL_TYPE = 'travelType';
    static FROM_DATE = 'fromDate';
    static FROM_TIME = 'fromTime';
    static TO_DATE = 'toDate';
    static TO_TIME = 'toTime';
    static DESTINATION_TYPE = 'destinationType';
    static REFERER_EVENT = 'refererEvent';
    static CLICKED_PRICE = 'clickedPrice';
    static SERVICE_ID = 'serviceId';
    static FAV = 'fav';
}
 